<template>
  <div class="container">
    <div class="content" v-if="navTopicList">
      <!--戏曲剧种-->
      <div id="xqjz">
        <div class="class1 content-wrapper">
          <div class="class1-header">
            <img src="~imgs/title-xqjz-bg.png" alt="剧种曲种">
            <ul>
              <li v-for="(item, index) of navTopicList['剧种曲种']"
                :key="item + index"
                :class="{select : selectIndex[0] === index}"
                @mouseover="handleClickTitle(index, 0, item.value, '剧种曲种')"
              >{{item.value}}</li>
            </ul>
          </div>
          <!--xqjzListItem-->
          <div class="class-content clear" v-if="xqjzListItem">
            <ul class="clear" id="xqjz-data-1">
              <li v-for="(item, index) of xqjzListItem"
                :key="index">
                <a class="title"  :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a>
                <a class="area" @click="handleItemDetail(item.BookID)">
                  <span class="no-cursor" >[ 来源 ] </span>
                  <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span>
                  </a>
              </li>
            </ul>
            <span class="more-class" @click="toSearchPage('剧种曲种', navTopicList['剧种曲种'][selectIndex[0]].value)" >查看更多 >></span>
          </div>
        </div>
      </div>
      
      <!--经典剧目-->
      <div id="jdjm">
          <div class="class2 content-wrapper">
            <div class="class2-header">
              <img src="~imgs/title-jdqm-bg.png" alt="剧目曲目">
              <div class="line"></div>
              <ul>
                <li v-for="(item, index) of navTopicList['剧目曲目']"
                    :key="index"
                    :class="{select: selectIndex[1] === index}"
                    @mouseover="handleClickTitle(index, 1, item.value, '剧目曲目')"
                    >{{item.value}}</li>
              </ul>
            </div>
            <div class="class-content clear" v-if="jdjmListItem">
                <ul class="clear" id="jdjm-data-1">
                    <li v-for="(item, index) of jdjmListItem"
                    :key="index"><a class="title"  :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor" >[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a></li>
                </ul>
                <span class="more-class" @click="toSearchPage('剧目曲目', navTopicList['剧目曲目'][selectIndex[1]].value)" >查看更多 >></span>
            </div>
          </div>
      </div>

      <div id="yyby">
          <div class="class3 content-wrapper">
              <div class="class2-header">
                  <img src="~imgs/title-yyby-bg.png" alt="音乐表演">
                  <div class="line"></div>
                  <ul>
                      <li v-for="(item, index) of navTopicList['音乐表演']"
                          :key="index"
                          :class="{select: selectIndex[2] === index}"
                          @mouseover="handleClickTitle(index, 2, item.value, '音乐表演')"
                >{{item.value}}</li>
                  </ul>
              </div>
              <div class="class-content clear" v-if="yybyListItem">
                  <ul class="clear" id="yyby-data-1">
                    <li v-for="(item, index) of yybyListItem"
                   
                  :key="index"><a class="title" :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor">[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a></li>
                  </ul>
                  <span class="more-class" @click="toSearchPage('音乐表演', navTopicList['音乐表演'][selectIndex[2]].value)" >查看更多 >></span>
              </div>
          </div>
      </div>
      <div id="wtms">
          <div class="class4 content-wrapper">
              <div class="class2-header">
                  <img src="~imgs/title-wtms-bg.png" alt="舞台美术">
                  <div class="line"></div>
                  <ul>
                      <li v-for="(item, index) of navTopicList['舞台美术']"
                          :key="index"
                          :class="{select: selectIndex[3] === index}"
                          @mouseover="handleClickTitle(index, 3, item.value, '舞台美术')"
                >{{item.value}}</li>
                  </ul>
              </div>
              <div class="class-content clear" v-if="wtmsListItem">
                  <ul class="clear" id="wtms-data-1">
                    <li v-for="(item, index) of wtmsListItem"
                   
                  :key="index"><a class="title" :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor">[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a></li>
                  </ul>
                  <span class="more-class" @click="toSearchPage('舞台美术', navTopicList['舞台美术'][selectIndex[3]].value)" >查看更多 >></span>
              </div>
          </div>
      </div>

      <div id="jtjg">
          <div class="class5 content-wrapper">
              <div class="class2-header">
                  <img src="~imgs/title-jtjg-bg.png" alt="戏曲机构">
                  <div class="line"></div>
                  <ul>
                    <li v-for="(item, index) of navTopicList['戏曲机构']"
                          :key="index"
                          :class="{select: selectIndex[4] === index}"
                          @mouseover="handleClickTitle(index, 4, item.value, '戏曲机构')"
                >{{item.value}}</li>
                  </ul>
              </div>
              <div class="class-content clear" v-if="jtjgListItem">
                  <ul class="clear" id="jtjg-data-1">
                    <li v-for="(item, index) of jtjgListItem"
                   
                  :key="index"><a class="title" :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor">[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a></li>
                  </ul>
                  <span class="more-class" @click="toSearchPage('戏曲机构', navTopicList['戏曲机构'][selectIndex[4]].value)" >查看更多 >></span>
              </div>
          </div>
      </div>

      <div id="xqzj" v-if="imgListSix">
          <div class="class6 content-wrapper">
              <div class="class6-header" v-if="xqzjListItem">
                  <div class="line"></div>
                  <ul>
                    <li @mouseover="handleClickTitle(index, 5, item.name, item.name)"
                        v-for="(item, index) of imgListSix"
                        :key="index"
                        :class="{select: selectIndex[5] === index}"
                        >
                      <img :src="item.src" alt="戏曲杂记">
                    </li>
                  </ul>
                  <span class="more-class" @click="toSearchPage(imgListSix[selectIndex[5]].name, imgListSix[selectIndex[5]].name)" >查看更多 >></span>
              </div>

              <div class="class-content clear">
                  <ul class="clear" id="xqzj-data-1">
                      <li v-for="(item, index) of xqzjListItem"
                       
                        :key="index"><a class="title" :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor">[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>

      <div id="ycxs" v-if="imgListSev">
          <div class="class7 content-wrapper">
              <div class="class7-header" v-if="ycxsListItem">
                  <div class="line"></div>
                  <ul>
                      <li @mouseover="handleClickTitle(index, 6, item.name, item.name)"
                        v-for="(item, index) of imgListSev"
                        :key="index"
                        :class="{select: selectIndex[6] === index}"
                        >
                      <img :src="item.src" alt="演出习俗">
                    </li>
                  </ul>
                  <span class="more-class" @click="toSearchPage(imgListSev[selectIndex[6]].name, imgListSev[selectIndex[6]].name)" >查看更多 >></span>
              </div>
              <div class="class-content clear">
                  <ul class="clear" id="ycxs-data-1">
                      <li v-for="(item, index) of ycxsListItem"
                       
                        :key="index"><a class="title" :title="item.Title" @click="handleClickItemRead(item.Id)">{{item.Title}}</a><a class="area" @click="handleItemDetail(item.BookID)"><span class="no-cursor">[ 来源 ] </span> <span :title="item.BookTitle">{{item.BookTitle | ellipsis}}</span></a></li>
                  </ul>
              </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
import { async } from 'q'
import {mapState, mapGetters} from 'vuex'
import '../../api'
import {READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL} from '../../store/mutation-types'
export default {
  name: 'Home',
  data () {
    return {
      xqjzListItem:[],
      jdjmListItem:[],
      yybyListItem:[],
      wtmsListItem:[],
      jtjgListItem:[],
      xqzjListItem:[],
      ycxsListItem:[],
      selectIndex: [0, 0, 0, 0, 0, 0, 0], // 选中标识
      imgListSev: [
        {src:require('@/assets/imgs/title-ycxs.png'),name:'演出习俗'}, 
        {src:require('@/assets/imgs/title-wwgj.png'),name:'文物古迹'},
        {src:require('@/assets/imgs/title-zj.png'),name:'传记'},
        {src:require('@/assets/imgs/title-tp.png'),name:'图片'},
        {src:require('@/assets/imgs/title-tb.png'),name:'图表'}
        ],
      imgListSix: [
        {src:require('@/assets/imgs/title-xqzj.png'),name:'戏曲杂记'}, 
        {src:require('@/assets/imgs/title-yccs.png'),name:'演出场所'},
        {src:require('@/assets/imgs/title-twcs.png'),name:'轶闻传说'},
        {src:require('@/assets/imgs/title-bkzz.png'),name:'报刊专著'},
        {src:require('@/assets/imgs/title-yykj.png'),name:'谚语口诀'}]
      }
  },
  filters: {
    ellipsis(value) {
    if (!value) return;
    let temp = value.trim()
    if (temp.length > 10 ){
      return temp.slice(0, 10) + "...";
    }
    return temp;
  }
  },
  methods: {
    async handleClickItemRead (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 条目1
        this.$store.dispatch('savSourceType', 1)
        if(this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          //window.location.href = READ_URL + id + RESOURCE_TYPE_ITEM_READ
          window.open(READ_URL + id + RESOURCE_TYPE_ITEM_READ)
        }else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    async handleItemDetail (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        //this.$router.push({path: '/detail', id :{BookID: window.escape(BookID)}})
        this.$router.push({
          path: '/detail', 
          query: { BookID: id} 
        })
      }
    },
    _initToReading () {
      const id = this.$route.query.BookId
      window.open(READ_URL + id + RESOURCE_TYPE_ITEM_READ)
    },
    // 携带条件跳转检索页
    async toSearchPage (title, sectitle) {
      if (await this.$loginAuthentication.intercept(0)) {
        const list = []
        const listq = []
        if(title === sectitle) {
          list.push("专题分类:"+title)
          listq.push('CategoryA:'+ title)
        }else {
          list.push("专题分类:" + title + "-" + sectitle)
          listq.push(`CategoryB:${title}#${sectitle}`)
        }
        this.$store.dispatch('savaFilterList', list)
        this.$store.dispatch('savaFilterQuery', listq)
        this.$router.push({path: 'search'})
      }
    },
    handleClickTitle (index, num, item, itemfir) {
      this.selectIndex.splice(num,1,index)
      let opt = {}
      switch (num) {
        //{city: "青岛市",province: "山东省",index: 0}
        case 0:
          opt.index = num
          opt.fq = [`CategoryB:${itemfir}#${item}`]
          this.getIndexItem(opt)
          break;
        case 1:
          opt.index = num
          opt.fq = [`CategoryB:${itemfir}#${item}`]
          this.getIndexItem(opt)
          break;
        case 2:
          opt.index = num
          opt.fq = [`CategoryB:${itemfir}#${item}`]
          this.getIndexItem(opt)
          break;
        case 3:
          opt.index = num
          opt.fq = [`CategoryB:${itemfir}#${item}`]
          this.getIndexItem(opt)
          break;
        case 4:
          opt.index = num
          opt.fq = [`CategoryB:${itemfir}#${item}`]
          this.getIndexItem(opt)
          break;
        case 5:
          opt.index = num
          opt.fq = ['CategoryA:'+itemfir]
          this.getIndexItem(opt)
          break;
        case 6:
          opt.index = num
          opt.fq = ['CategoryA:'+itemfir]
          this.getIndexItem(opt)
          break;
        default:
          break;
      }
    },
    // 获取首页条目
    getIndexItem(opt) {
      this.$http.post('/api/v1/search', {
        fq: opt.fq,
        core: 'LocalChronicleItemOpera',
        pageSize: 12,
        returnFeild : ['Id', 'Title','BookID', 'BookTitle']
      }).then((res) => {
        if(res.status===200 && res.data) {
          const data = res.data.resulter
          //JSON.parse(data.results)[0]
          const arrs = JSON.parse(data.results)
          //console.log(arrs)
          switch (opt.index) {
            case 0 :
              this.xqjzListItem = arrs
              break;
            case 1 :
              this.jdjmListItem  = arrs
              break;
            case 2 :
              this.yybyListItem  = arrs
              break;
            case 3 :
              this.wtmsListItem  = arrs
              break;
            case 4 :
              this.jtjgListItem  = arrs
              break;
            case 5 :
              this.xqzjListItem  = arrs
              break;
            case 6 :
              this.ycxsListItem  = arrs
              break;
            default:
              break;
          }
          //return arrs
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    // const opt1= {CategoryB: "曲种",CategoryA: "剧种曲种",index: 0}
    // const opt2= {CategoryB: "曲目",CategoryA: "剧目曲目",index: 1}
    // const opt3= {CategoryB: "音乐",CategoryA: "音乐表演",index: 2}
    // const opt4= {CategoryB: "舞台",CategoryA: "舞台美术",index: 3}
    // const opt5= {CategoryB: "班社与剧团",CategoryA: "戏曲机构",index: 4}
    // const opt6= {CategoryA: "戏曲杂记",index: 5}
    // const opt7= {CategoryA: "演出习俗",index: 6}
    
    this.xqjzListItem = this.handleClickTitle(0, 0, '曲种', '剧种曲种')
    this.jdjmListItem = this.handleClickTitle(0, 1, '曲目', '剧目曲目')
    this.yybyListItem = this.handleClickTitle(0, 2, '音乐', '音乐表演')
    this.wtmsListItem = this.handleClickTitle(0, 3, '舞台', '舞台美术')
    this.jtjgListItem = this.handleClickTitle(0, 4, '班社与剧团', '戏曲机构')
    this.xqzjListItem = this.handleClickTitle(0, 5, '戏曲杂记', '戏曲杂记')
    this.ycxsListItem = this.handleClickTitle(0, 6, '演出习俗', '演出习俗')
    // 分发获取标题数据事件
    this.$store.dispatch('getIndexNav')
  },
  computed: {
    // 首页标题分类数据
    ...mapState(['indexNavList', 'userinfo', 'upCouter']),
    ...mapGetters(['navTopicList'])
  }
}
</script>

<style lang="less" scoped>
@import url(~styles/mixins.less);
@import url(~styles/varibles.less);
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.container {
  height: 3547px;
}
li {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.no-cursor {
  cursor: auto;
  user-select: none;
}
  #xqjz{
    height: 523px;
    position: relative;
    background: url(~imgs/class1-bg.png) no-repeat #fbf9f8;
    background-position: 0 179px;
    .class1{
      .class1-header{
        padding: 36px 0;
        ul{
          float: right;
          height: 80px;
          width: 1034px;
          li{
            float: left;
            //margin: 15px 19px;
            color: @topic-color;
            cursor: pointer;
            width: 82px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            // &:hover{
            //   transform: scale(1.1);
            // }
          }
          .select{
            color: #a31f24;
            background-image: url(~imgs/sec-title-hover-bg.png);
          }
        }
      }
      .class-content{
        ul{
          li{
            .content();
            .title{
              .content-title()
            }
            .area{
              .content-area()
            }
          }
        }
        .more-class{
          .more-class()
        }
      }
    }
  }
  #jdjm{
    height: 510px;
    position: relative;
    background: url(~imgs/class2-bg.png) no-repeat #ffffff;
    background-position: right bottom;
    .class2-header{
      padding: 36px 0;
      width: 100%;
      height: 36px;
      img{
        float: left;
        height: 76px;
      }
      .line{
        .line()
      }
      ul{
        float: right;
        position: relative;
        top: 20px;
        li{
          .header-li()
        }
        .select{
          color: #a31f24;
          background-image: url(~imgs/sec-title-hover-bg.png);
        }
      }
    }
    .class-content{
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
      .more-class{
        .more-class()
      }
    }
  }
  #yyby{
    height: 518px;
    position: relative;
    background: url(~imgs/class3-bg.png) no-repeat #fbf9f8;
    background-position: left bottom;
    .class2-header{
      padding: 36px 0;
      width: 100%;
      height: 36px;
      img{
        float: left;
        height: 76px;
      }
      .line{
        .line()
      }
      ul{
        float: right;
        position: relative;
        top: 20px;
        li{
          .header-li()
        }
        .select{
          color: #a31f24;
          background-image: url(~imgs/sec-title-hover-bg.png);
        }
      }
    }
    .class-content{
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
      .more-class{
        .more-class()
      }
    }
  }
  #wtms{
    height: 507px;
    position: relative;
    background: url(~imgs/class4-bg.png) no-repeat #ffffff;
    background-position: right bottom;
    .class2-header{
      padding: 36px 0;
      width: 100%;
      height: 36px;
      img{
        float: left;
        height: 76px;
      }
      .line{
        .line()
      }
      ul{
        float: right;
        position: relative;
        top: 20px;
        li{
          .header-li()
        }
        .select{
          color: #a31f24;
          background-image: url(~imgs/sec-title-hover-bg.png);
        }
      }
    }
    .class-content{
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
      .more-class{
        .more-class()
      }
    }
  }
  #jtjg{
    height: 513px;
    position: relative;
    background: url(~imgs/class5-bg.png) no-repeat #fbf9f8;
    background-position: left bottom;
    .class2-header{
      padding: 36px 0;
      width: 100%;
      margin-left: 34px;
      height: 36px;
      img{
        float: left;
        height: 76px;
      }
      .line{
        .line()
      }
      ul{
        float: right;
        position: relative;
        top: 20px;
        li{
          .header-li();
          width: 113px;
        }
        .select{
          color: #a31f24;
          background-image: url(~imgs/topicSelectBg.png);
        }
      }
    }
    .class-content{
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
      .more-class{
        .more-class()
      }
    }
  }
  #xqzj{
    height: 481px;
    position: relative;
    background: url(~imgs/class6-bg.png) no-repeat #ffffff;
    background-position: right bottom;
    .class6-header{
      width: 972px;
      background-color: #f2e5df;
      height: 36px;
      margin-top: 80px;
      position: absolute;
      ul{
        position: relative;
        top: -48px;
        left: 32px;
        li{
          position: relative;
          float: left;
          background: url(~imgs/last-two-bg.png) no-repeat center;
          width: 140px;
          height: 80px;
          cursor: pointer;
          &:hover{
            // opacity: .5;
          }
          img{
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -13px 0 0 -48px;
          }
        }
        .select{
          background: url(~imgs/last-two-bg-hover.png) no-repeat center;
        }
      }
      .more-class{
        .more-class();
        position: relative;
        top: -13px;
        right: -221px;
      }
    }
    .class-content{
      padding-top: 132px;
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
    }
  }
  #ycxs{
    height: 495px;
    position: relative;
    background: url(~imgs/class7-bg.png) no-repeat #fbf9f8;
    background-position: left bottom;
    .class7-header{
      width: 972px;
      background-color: #f2e5df;
      height: 36px;
      margin-top: 80px;
      position: absolute;
      ul{
        position: relative;
        top: -48px;
        left: 32px;
        li{
          position: relative;
          float: left;
          background: url(~imgs/last-two-bg.png) no-repeat center;
          width: 140px;
          height: 80px;
          text-align: center;
          cursor: pointer;
          &:hover{
            // background: url(~imgs/last-two-bg-hover.png) no-repeat center;
            // opacity: .5;
          }
          &::after{
            content: "";
            display: inline-block;
            height: 100%;
            width: 0px;
            vertical-align: middle;
          }
          img{
            vertical-align: middle;
          }
        }
        .select{
          background: url(~imgs/last-two-bg-hover.png) no-repeat center;
        }
      }
      .more-class{
        .more-class();
        position: relative;
        top: -13px;
        right: -221px;
      }
    }
    .class-content{
      padding-top: 145px;
      ul{
        li{
          .content();
          .title{
            .content-title()
          }
          .area{
            .content-area()
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue